export const QUIZ_WITHOUT_BRAND_IDS = {
  MULTIBRAND_QUIZ: -1,
  QUESTION_OF_THE_DAY_ID: -2,
  EVENT_MODE: -3,
  SINGLE_MODE: -4,
};
